/**
 * Created by amitt
 *
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/usersSetConcurrencyDialogInnerView.tmpl");
    var InputField = require("ui/input-field/InputField");
    var RadioButtonList = require("ui/radio-button-list/RadioButtonList");

    var UsersSetConcurrencyDialogInnerView = {};

    var MAX_ASYNC_CHAT_RADIO_OPTIONS = {
        ACCOUNT: "account",
        CUSTOM: "custom"
    };

    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {
        UsersSetConcurrencyDialogInnerView = Marionette.Layout.extend({

            template: template,
            ui: {
                maxAsyncChats: ".set-concurrency-max-async-chats-radio-list"
            },
            uiComponents: {
                customMaxAsyncChatsInput: {
                    type: InputField,
                        options: {
                        permutation: InputField.Permutation.E,
                            placeholder: LE.translator.translate("LEUserManagement.userList.setConcurrency.maxAsyncChats.radio.customSettings.placeholder"),
                            inputType: InputField.prototype.InputTypeEnum.numbersBetweenMinToMax,
                            range: { min: 0, max: 999 },
                            zIndexBubble: 10001 // todo how to do this properly? can I get 'this' z-index and use it? I know that dialog z-index is 10,000
                    },
                    events: {
                        "change": "_onMaxAsyncChatsChanged"
                    }
                },
                maxAsyncChatsRadioList: {
                    type: RadioButtonList,
                    options: {
                        items: "view._getMaxAsyncChatsRadioItems",
                        el: "view.ui.maxAsyncChats",
                        allowHtml: true,
                        permutation: RadioButtonList.PERMUTATION.A,
                        defaultSelection: MAX_ASYNC_CHAT_RADIO_OPTIONS.CUSTOM
                    },
                    events: {
                        "change": "_onRadioSelectionChanged"
                    }
                }
            },

            initialize: function (options) {
                this.modelValidators = options.modelValidators;
                this.maxConversationsSettings = options.maxConversationsSettings;
            },

            _getMaxAsyncChatsRadioItems: function () {
                var accountSettingsPart1 = LE.translator.translate("LEUserManagement.userList.setConcurrency.maxAsyncChats.radio.accountSettings.text.part1");
                var accountSettingsPart2 = LE.translator.translate({key: "LEUserManagement.userList.setConcurrency.maxAsyncChats.radio.accountSettings.text.part2", args: [this.maxConversationsSettings]});

                return [
                    {
                        key: MAX_ASYNC_CHAT_RADIO_OPTIONS.ACCOUNT,
                        label: "<span>" + accountSettingsPart1 + "</span> <span class=\"dialog-radio-button-label-inner\">" + accountSettingsPart2 + "</span>",
                        allowHtml: true
                    },
                    {
                        key: MAX_ASYNC_CHAT_RADIO_OPTIONS.CUSTOM,
                        label: LE.translator.translate("LEUserManagement.userList.setConcurrency.maxAsyncChats.radio.customSettings.text"),
                        embeddedView: this.uiComponents.customMaxAsyncChatsInput
                    }
                ];
            },

            _onRadioSelectionChanged: function(componentId, eventName, radioOption) {
                var value;
                switch (radioOption) {
                    case MAX_ASYNC_CHAT_RADIO_OPTIONS.ACCOUNT:
                        value = null;
                        break;
                    case MAX_ASYNC_CHAT_RADIO_OPTIONS.CUSTOM:
                        value = this.uiComponents.customMaxAsyncChatsInput.getValue();
                        break;
                }
                this._changeMaxAsyncChatsValue(value);
            },

            _onMaxAsyncChatsChanged: function(componentId, eventName, value) {
                this._changeMaxAsyncChatsValue(value);
            },

            _changeMaxAsyncChatsValue: function(value) {
                this.trigger("concurrencyInnerView:maxAsyncChatsChanged", value);
            }
        });
    });

    return UsersSetConcurrencyDialogInnerView;
});
